/* global console */
(function (global) {
  'use strict';

  // Fetch configuration immediately on load
  var mergedConfig = null;
  if (global.wsConfig) {
    var fetchedConfig = JSON.parse($.ajax({
      type: "GET",
      dataType: "json",
      url: global.wsConfig.apiUrl + "/configuration",
      async: false,
      error: function fetchConfigurationError(response) {
        console.log("Configuration fetch failed with response status " + response.status);
      }
    }).responseText || "{}");

    // Merge fetched result with static config
    mergedConfig = angular.extend({}, global.wsConfig, fetchedConfig);
  }
  angular.module('wsLrs.services').factory('Config', function () {
    return {
      config: mergedConfig,
      get: function get() {
        return this.config;
      }
    };
  });
})(window);
